module.exports = __webpack_public_path__ + "ath_game_web/img/button-arrow-up.9f0fd060.svg";